// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { squareX16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-square-x': IconSquareX;
    }
}

/**
 * The icon component for the 'squareX' icon
 */
export class IconSquareX extends IconSvg {
    public constructor() {
        super(squareX16X16);
    }
}

registerIconSvg('icon-square-x', IconSquareX);
export const iconSquareXTag = 'nimble-icon-square-x';
